export const FIND_REGULAMENTO = 'FIND_REGULAMENTO'
export const FIND_REGULAMENTO_PENDING = 'FIND_REGULAMENTO_PENDING'
export const FIND_REGULAMENTO_SUCCESS = 'FIND_REGULAMENTO_SUCCESS'
export const FIND_REGULAMENTO_FAILURE = 'FIND_REGULAMENTO_FAILURE'